import { ContactsLayout } from './components/ContactsLayout';

/**
 * 联系人模块
 */
export default function ContactsPage() {
  return <ContactsLayout />;
}

